module.exports = "/_next/static/images/red-dress-bladder-pain@2x-min-78bf994a43e96cc54d7430ea031dcc0c.png.webp";